import * as React from "react";
import ExpandableFormSection from "../../../../../components/form/Sections/ExpandableFormSection";
import Summary from "../../../../../components/form/Sections/Summary";
import RadioButton from "../../../../../primitiveComponents/form/RadioButton/RadioButton";
import RadioButtonGroup from "../../../../../primitiveComponents/form/RadioButton/RadioButtonGroup";
const styles = require("./style.less");

interface PackageDownloadOptionsProps {
    forcePackageDownload: boolean;
    onOptionChanged(value: boolean): void;
}

const PackageDownloadOptions: React.StatelessComponent<PackageDownloadOptionsProps> = (props) => {
    return (
        <ExpandableFormSection title="Package download" errorKey="options" help="Choose whether to force re-downloading packages" summary={buildSummary()}>
            <RadioButtonGroup value={props.forcePackageDownload} onChange={props.onOptionChanged}>
                <RadioButton value={false} label="Use cached packages (if available)" isDefault={true} />
                <RadioButton value={true} label="Re-download packages from feed" />
            </RadioButtonGroup>
        </ExpandableFormSection>
    );

    function buildSummary() {
        return props.forcePackageDownload ? Summary.summary("Re-download packages from feed") : Summary.default("Use cached packages (if available)");
    }
};
export default PackageDownloadOptions;
